// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// aliased
// import Section from 'components/Section';
// import conditions from 'data/conditions';
// import SectionHeader from 'components/SectionHeader';
// import StethoscopeIcon from 'components/StethoscopeIcon';
import Link from 'components/Link';

// local
import styles from './NewsItem.pcss';

export default class NewsItem extends PureComponent {
  
  static propTypes = {
    className: PropTypes.string,
    news: PropTypes.shape({
      image: PropTypes.string,
      title: PropTypes.string,
      subTitle: PropTypes.string,
      url: PropTypes.string,
    }),
  }
  static defaultProps = {}
  
    
  render() {
    const { className, news } = this.props;
    const classNames = classnames(className, styles.newsItem);
    
    return (
      <Link to={ news.url } className={ classNames } title={ 'View Article' }>
        <div className={ styles.inner }>
          <div className={ styles.imgWrap }>
            <img src={ news.image } />
          </div>
          <div className={ styles.txtWrap }>
            <h3 className={ styles.publisher } >{ news.publisher }</h3>
            <div className={ styles.date } >{ news.date }</div>
            <i className={ styles.title } >{ news.title }</i>
            { news.subTitle  && <i className={ styles.subTitle } >{ news.subTitle }</i> }
          </div>
        </div>
      </Link>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NewsSection/NewsItem/index.jsx